import { useEffect } from 'react';

export type EffectFunction = () => Promise<void>;

/**
 * React does not support async functions as effects
 * so we need to wrap it in a sync function that throws away the promise
 * @param effect
 * @param dependencies
 *  Attention, this can decrease the performance extremly if too much components do this on a page
 */

export const useAsyncEffect = (effect: EffectFunction, dependencies: any[]) => {
  const func = useEffect;

  return func(() => {
    const asyncFunction = async () => {
      effect();
    };

    asyncFunction();
  }, dependencies);
};
